<script setup lang="ts">
/**
 * Ask Schorschi from anywhere: a panel at the side (full screen on a phone)
 * with the same chat as the Schorschi page — the answer being written shows
 * in both. ⌘J / Ctrl+J toggles it (also from inside text fields), the command
 * palette opens it with a question (`openSchorschi`). Mounted once by the app
 * shell; only for people who may read Schorschi.
 */
import { useEventListener } from "@vueuse/core";
import { computed, defineAsyncComponent } from "vue";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { useSession } from "@/composables/useSession";
import { panel, toggleSchorschi } from "./panel";

// Loaded on first open: the chat, the avatar and the cards stay out of every page's bundle.
const PanelBody = defineAsyncComponent(() => import("./chat/PanelBody.vue"));

const { can } = useSession();
const allowed = computed(() => can("schorschi.read"));

useEventListener(window, "keydown", (e: KeyboardEvent) => {
  if ((e.metaKey || e.ctrlKey) && !e.shiftKey && !e.altKey && e.key.toLowerCase() === "j" && allowed.value) {
    e.preventDefault();
    toggleSchorschi();
  }
});
</script>

<template>
  <Sheet v-if="allowed" v-model:open="panel.open">
    <SheetContent side="right" class="w-full gap-0 p-0 sm:max-w-lg lg:max-w-xl" @open-auto-focus.prevent>
      <PanelBody />
    </SheetContent>
  </Sheet>
</template>
